<template>
    <page :busy="busy">
        <b-container fluid class="my-3" v-if="propertiesLoaded && guestLoaded">
            <reservation-details-form
                :is-create="true"
                :initial-values="{
                    id: reservationDetails.id,
                    user_id: reservationDetails.user_id,
                    full_name: reservationDetails.full_name,
                    email: reservationDetails.email,
                    first_name: reservationDetails.first_name,
                    last_name: reservationDetails.last_name,
                    from_date: reservationDetails.from_date,
                    to_date: reservationDetails.to_date,
                    auto_generate: reservationDetails.auto_generate,
                    is_quote: reservationDetails.is_quote,
                    properties: reservationDetails.properties,
                    adults: reservationDetails.adults,
                    children: reservationDetails.children,
                    pets: reservationDetails.pets,
                    stay_type: reservationDetails.stay_type,
                    discount_pk: reservationDetails.discount_pk,
                    inquiry_pk: reservationDetails.inquiry_pk,
                }"
                ref="reservationDetailsForm"
            ></reservation-details-form>
        </b-container>
    </page>
</template>

<script>
    import isNil from 'lodash/isNil';
    import { mapState } from 'vuex';
    import API from '../../../api';
    import { removeScrollMixin } from '../../../mixins/remove-scroll-mixin';
    import Page from '../../generic/page/page.vue';
    import Reservation from '../reservation.vue';
    import ReservationDetailsForm from './reservation-details-form.vue';
    import { RESERVATION_DETAILS_PROPERTIES_ENDPOINT } from '../../../endpoints';

    export default {
        extends: Reservation,
        name: 'ReservationDetailsCreate',
        mixins: [removeScrollMixin],
        components: {
            ReservationDetailsForm,
            Page,
        },
        computed: {
            ...mapState('reservation', ['reservationDetails']),
            reservationId() {
                return parseInt(this.$route.params.id);
            },
            currentTab() {
                return this.tabs.findIndex(tab => tab.active);
            },
            tabs() {
                return [
                    {
                        title: 'Details',
                        route: `/app/reservation/create`,
                        active: true,
                    },
                ];
            },
        },
        data() {
            return {
                propertiesLoaded: false,
                guestLoaded: false,
            };
        },
        mounted() {
            this.$store.commit('reservation/resetReservationDetails');
            this.reservationDetails.id = null;
            this.reservationDetails.user_id = parseInt(this.$route.query.user) || null;
            this.reservationDetails.first_name = '';
            this.reservationDetails.last_name = '';
            this.reservationDetails.email = '';
            this.reservationDetails.adults = parseInt(this.$route.query.adult) || 1;
            this.reservationDetails.children = parseInt(this.$route.query.children) || 0;
            this.reservationDetails.pets = parseInt(this.$route.query.pets) || 0;
            this.reservationDetails.discount_pk = parseInt(this.$route.query.discount_pk) || 0;
            this.reservationDetails.auto_generate = false;
            this.reservationDetails.is_quote = this.$route.query.quote == 1;
            this.reservationDetails.stay_type = 'GUEST';
            this.reservationDetails.disallow_source_editing = true;
            this.reservationDetails.inquiry_source = { id: null };
            this.reservationDetails.inquiry_pk = parseInt(this.$route.query.inquiry_pk) || 0;

            if (!isNil(this.reservationDetails.user_id)) {
                this.fetchReservationDetailsGuest(this.reservationDetails.user_id);
            } else {
                this.guestLoaded = true;
            }

            if (this.$route.query.predefined_tech_reservations != undefined) {
                this.reservationDetails.properties = [];
                const tech_reservations = this.$route.query.predefined_tech_reservations.split('|');
                for (let i = 0; i < tech_reservations.length; i++) {
                    const values = tech_reservations[i].split(',');
                    let property_id = parseInt(values[0]);
                    let room_id = null;
                    if (property_id < 0) {
                        room_id = -property_id;
                        property_id = null;
                    }
                    this.reservationDetails.properties.push({
                        property_id: property_id,
                        room_id: room_id,
                        adults: this.reservationDetails.adults,
                        children: this.reservationDetails.children,
                        pets: this.reservationDetails.pets,
                    });
                    this.reservationDetails.from_date = values[1] || '';
                    this.reservationDetails.to_date = values[2] || '';
                }
            }

            this.fetchReservationDetailsProperties();
        },
        beforeUnmount() {
            this.$store.commit('reservation/resetReservationDetails');
        },
        methods: {
            async fetchReservationDetailsProperties() {
                const response = await API.post(`/app/reservation/details/properties/`, this.reservationDetails);
                this.reservationDetails.properties = response.data;
                this.propertiesLoaded = true;
            },
            async fetchReservationDetailsGuest(id) {
                const response = await API.get(`/app/reservation/details/${id}/guest/`);
                this.reservationDetails.first_name = response.data.first_name;
                this.reservationDetails.last_name = response.data.last_name;
                this.reservationDetails.email = response.data.email;
                this.reservationDetails.full_name = response.data.full_name;
                this.guestLoaded = true;
            },
        },
    };
</script>
